/* globals getComputedStyle */
import throttle from 'raf-throttle';

const WALLPAPER_MAGIC_NUMBER = 71; // Find a better way to fetch this...

const generateTagFriendlyName = (tagName) =>
    `vg_${tagName
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/,+/g, '')
        .replace(/å/g, 'aa')
        .replace(/ø/g, 'oe')
        .replace(/æ/g, 'ae')}`;

const deviceKeywordMap = (device) => {
    const deviceMap = {
        mobile: 'phone',
        'mobile-app': 'phone',
        'tablet-app': 'tablet',
    };

    return deviceMap[device] || device;
};

export const getSupplyType = (device) => {
    let supplyType = '';

    switch (device) {
        case 'desktop':
            supplyType = 'web_desktop';
            break;

        case 'tablet-app':
        case 'tablet':
            supplyType = 'web_tablet';
            break;

        case 'mobile-app':
        case 'mobile':
            supplyType = 'web_phone';
            break;

        default:
            supplyType = 'web_desktop';
    }

    return supplyType;
};

const setBodyBackgroundPosition = (height) => {
    document.body.style.setProperty('background-position', `center ${height}px`, 'important');
};

/* eslint-disable consistent-return */
export const updateWallpaperPosition = async (node) => {
    const getScrollY = () => window.scrollY || window.pageYOffset;

    const updatePosition = new Promise((resolve) => {
        throttle(() => {
            const top = node.getBoundingClientRect().top + getScrollY();
            const backgroundPosition =
                top + parseInt(getComputedStyle(node).paddingTop.replace('px'), 10);

            setBodyBackgroundPosition(backgroundPosition);

            return resolve({
                top,
                backgroundPosition,
            });
        })();
    });

    const { backgroundPosition } = await updatePosition;

    window.addEventListener(
        'scroll',
        throttle(() => {
            if (getScrollY() >= backgroundPosition - WALLPAPER_MAGIC_NUMBER) {
                setBodyBackgroundPosition(WALLPAPER_MAGIC_NUMBER);
            } else {
                setBodyBackgroundPosition(backgroundPosition - getScrollY());
            }
        }),
    );
};
/* eslint-enable */

export const getArticleAdKeywords = (articleObj, device) => {
    const keywords = {};
    const { section, tags } = articleObj;
    if ((section === undefined && tags === undefined) || Object.keys(section).length === 0) {
        return {};
    }

    // If parent is set, use that at main appnexus keyword
    if (section.parent !== undefined) {
        keywords['no-sno-news-section'] = section.parent.title;
        keywords['no-sno-news-subsection'] = section.title;
    } else {
        keywords['no-sno-news-section'] = section.title;
    }

    // Send all tags as an array
    if (tags !== undefined && tags.length > 0) {
        const tagNames = tags.map((tag) => tag.title);
        keywords['no-sno-news-sponsors'] = tagNames;
    }

    Object.keys(keywords).forEach((key) => {
        if (Array.isArray(keywords[key])) {
            keywords[key] = keywords[key].map((tag) => generateTagFriendlyName(tag));
        } else {
            keywords[key] = generateTagFriendlyName(keywords[key]);
        }
    });

    // Supply type should be without "vg_"-prefix
    const supplyType = getSupplyType(device);
    keywords['aa-sch-supply_type'] = supplyType;
    keywords['no-sno-device'] = deviceKeywordMap(device);

    return keywords;
};

export const getAdUserId = () => {
    const cookie =
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    `(?:(?:^|.*;)\\s*${encodeURIComponent('_pulse2data').replace(
                        /[-.+*]/g,
                        '\\$&',
                    )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
                ),
                '$1',
            ),
        ) || false;

    if (cookie) {
        return cookie.split(',')[9];
    }

    return null;
};



/** WEBPACK FOOTER **
 ** ./src/ads/helpers.js
 **/